import { forwardRef, Fragment, PropsWithChildren, useEffect, useState } from "react";
import { ITrimmedProps } from "./trimmed.props";
import { usePPA } from "context/ppa-context";
import { ForwardRefComponent } from "@fluentui/react-components";

export default function Trimmed(props: PropsWithChildren<ITrimmedProps>) {
    const { hasPermission } = usePPA();

    if (!hasPermission(props.permission, props.requireAll))
        return (<></>);

    return (<>{props.children}</>);
}